module.exports = __webpack_public_path__ + "static/img/h-06.f26dc3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/h-06.png
// module id = ODA0
// module chunks = 1